<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'robot'
};
</script>

<style lang="less" scoped></style>
